<template>
  <Loader :loading="isLoading" />
  <router-view></router-view>
  <HelpdeskChatbot v-if="showPublicChatbot" />
</template>

<script>
import { computed, ref } from 'vue';
import Loader from './components/page-loader.vue';
import HelpdeskChatbot from './components/helpdesk-chatbot.vue';
import { useRoute, useRouter } from 'vue-router';

export default {
  name: 'App',
  components: {
    HelpdeskChatbot,
    Loader
  },
  setup() {
    const isLoading = ref(false);
    const router = useRouter();
    const route = useRoute();
    const publicChatbotPaths = [
      '/login',
      '/logout',
      '/forgot-password',
      '/reset-password',
      '/auth/signin',
      '/auth/logout',
      '/auth/reset-pwd',
    ];

    const showPublicChatbot = computed(() => publicChatbotPaths.includes(route.path));

    // Add route navigation guards to handle loading state
    router.beforeEach((to, from, next) => {
      isLoading.value = true;  // Show loader before route change
      next();
    });

    router.afterEach(() => {
      isLoading.value = false; // Hide loader after route change
    });

    return { isLoading, showPublicChatbot };
  }
}
</script>
